import http from './http';

export default {
  create(data, validationErrors = {}) {
    return http(validationErrors).post(`/v1/answering_sequences`, data);
  },
  update(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/answering_sequences/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/answering_sequences/${id}`);
  },
}
